var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[(_vm.flag)?_c('div',{staticClass:"hover-content",style:(_vm.styleObj)},[_vm._v("\n    "+_vm._s(_vm.content.txt)+" "),_c('span',{staticClass:"close-btn",on:{"click":_vm.close}},[_vm._v("×")]),_c('div',{staticClass:"tooltip-arrow",class:{
        'tooltip-arrow-bottom': _vm.position === 'bottom',
        'tooltip-arrow-right': _vm.position === 'right',
      }})]):_vm._e(),_vm._t("default",[_vm._v("tooltip")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }